import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import {
    DRIPSET_LOGO,
    NURSE_REVIEWED_IMAGE_SRC,
    HOSPITAL_REVIEWED_IMAGE_SRC,
} from '@constants/images';
import {
    RESET_PASSWORD_PATH,
    LOGIN_PATH,
    VERIFICATION_PATH,
    HELP_AND_SUPPORT_PATH,
} from '@constants/routes';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { useAppDispatch } from '@store/hooks';
import { logout } from '@store/reducers/auth/authReducer';
import { clearLocalStoragePreserveLanguage } from '@utils/utils';

const ReviewedPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    let userRole = 'nurse';

    const handleBackClick = () => {
        clearLocalStoragePreserveLanguage();
        dispatch(logout());
        navigate(LOGIN_PATH);
    };

    const support = () => {
        window.open(HELP_AND_SUPPORT_PATH, '_blank');
    };

    return (
        <div className="bg-white w-full min-h-screen over">
            <div className="flex items-center justify-between px-4 py-3">
                {/* <div
                    className="flex items-center cursor-pointer absolute top-0 mt-4 text-lg text-nero font-semibold"
                    onClick={handleBackClick}
                >
                    <FaArrowLeftLong className="mr-2 cursor-pointer" />
                    <span>{t('auth.back')}</span>
                </div> */}
                <div className="flex-grow flex justify-center">
                    <div className="logo-container">
                        <Link to={LOGIN_PATH}>
                            <img
                                src={DRIPSET_LOGO}
                                alt="Dripset_logo"
                                className="object-contain"
                            />
                        </Link>
                    </div>
                </div>
            </div>
            <div className="flex flex-col items-center justify-center mt-5">
                <div className="mx-auto flex justify-center mb-4">
                    {userRole == 'hospital' && (
                        <img
                            src={HOSPITAL_REVIEWED_IMAGE_SRC}
                            alt="OTP"
                            className="object-contain"
                        />
                    )}
                    {userRole == 'nurse' && (
                        <img
                            src={NURSE_REVIEWED_IMAGE_SRC}
                            alt="OTP"
                            className="object-contain"
                        />
                    )}
                </div>
                <div className="text-center">
                    <h3 className="text-2xl font-bold text-black mb-2">
                        {t('auth.reviewed.title')}
                    </h3>
                    <p className="text-grey test-sm font-normal mb-3">
                        {t('auth.reviewed.description')}
                        <br />
                        {t('auth.reviewed.description_1')}
                        <br />
                        {userRole == 'hospital' && (
                            <>
                                {t('auth.reviewed.description_2')}
                                <br />
                            </>
                        )}
                        {userRole == 'nurse' && (
                            <>
                                {t('auth.reviewed.description_nurse')}
                                <br />
                            </>
                        )}
                    </p>
                    {userRole == 'hospital' && (
                        <button
                            onClick={support}
                            className="btn w-5/6 mt-2 py-3 px-4 !bg-primary !hover:bg-primary text-white font-semibold rounded-lg"
                        >
                            {t('auth.reviewed.contact_support')}
                        </button>
                    )}
                    <button
                        onClick={handleBackClick}
                        className="btn w-4/5 mt-2 py-3 px-4 !bg-primary !hover:bg-primary text-white font-semibold rounded-lg"
                    >
                        {t('auth.reviewed.back')}
                    </button>
                </div>
            </div>
        </div>
    );
};
export default ReviewedPage;
